/**
 * Import Plyr + set up func to create audio players
 * @author Matt Haynes
 * @package Dunfermline
 */

import Plyr from 'plyr';

const AudioPlayer = audioFile => {
    const playerId = document.getElementById('audio-player');
    if (!playerId) return;

    playerId.src = audioFile;
    // eslint-disable-next-line
    const player = new Plyr(playerId);
};

export default AudioPlayer;
